// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/addons/ScrollToTop';
import Header from './components/Header';
import Home from './components/Home';
import AboutUs from './components/AboutUs';
import ContactUs from './components/ContactUs';
import VisaAssistance from './components/Visa/VisaAssistance';
import VisaDetails from './components/Visa/VisaDetails';
import VisaEnquiry from './components/Visa/VisaEnquiry';
import AttestationServices from './components/Attestation/AttestationServices';
import AttestationDetails from './components/Attestation/AttestationDetails';
import AttestationEnquiry from './components/Attestation/AttestationEnquiry';
import ITServices from './components/IT/ITServices';
import ITServiceDetails from './components/IT/ITServiceDetails';
import ITEnquiry from './components/IT/ITEnquiry';
import PickupDropEnquiry from './components/Other/PickupDropEnquiry';
import HandymanEnquiry from './components/Other/HandymanEnquiry';
import CourierComingSoon from './components/addons/CourierComingSoon';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/visa" element={<VisaAssistance />} />
        <Route path="/visa/:visaId" element={<VisaDetails />} />
        <Route path="/visa/enquiry/:visaId" element={<VisaEnquiry />} />
        <Route path="/attestation" element={<AttestationServices />} />
        <Route path="/attestation/:serviceId" element={<AttestationDetails />} />
        <Route path="/attestation/enquiry/:serviceId" element={<AttestationEnquiry />} />
        <Route path="/it" element={<ITServices />} />
        <Route path="/it/:serviceId" element={<ITServiceDetails />} />
        <Route path="/it/enquiry/:serviceId" element={<ITEnquiry />} />
        <Route path="/pickup-drop/enquiry" element={<PickupDropEnquiry />} />
        <Route path="/handyman/enquiry" element={<HandymanEnquiry />} />
        <Route path="/courier/book" element={<CourierComingSoon />} />
        <Route path="/courier/track" element={<CourierComingSoon />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
